import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Inspection from "./sections/Inspection";
import ServiceRegions from "./sections/ServiceRegions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Inspection />
      <ServiceRegions />
      <Footer />
    </div>;
}